import React from "react";
import { ProductPropsProps } from "./types";
import classes from "./product-props.module.scss";

const ProductProps = ({ offer }: ProductPropsProps) => {
    return (
        <div className={classes.ProductProps}>
            <h2 className={classes.ProductProps__title}>Характеристики</h2>

            <div className={classes.Props}>
                {offer.props.map((prop, index) => {
                    return (
                        <div key={index} className={classes.Prop}>
                            <div className={classes.PropName}>{prop.label}</div>
                            <div className={classes.PropValue}>{prop.value}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
export default ProductProps;